export const asNumberSafe = (
    value: number | string | null | undefined
): number => {
    if (value === null || value === undefined) {
        return 0;
    }
    if (typeof value === 'string') {
        const parsed = +value;
        if (isNaN(parsed)) {
            return 0;
        }
        return parsed;
    }
    return value;
};
